module.exports = __webpack_public_path__ + "media/images/img-angel-7510f087f403decc084f1bb217f65a5c.png";